<template>
	<div>
	    <div class="video-container" :class="{ 'video-docked' : videoDocked }">
	        <div class="video-container-inner">
	        	<div
	        		class="video"
					:id="playerId"
        		></div>
	        </div>
	    </div>
	   	<div class="video-placeholder" :style="{ height : videoHeight + 'px' }" v-if="videoDocked"></div>
	</div>
</template>

<script>
	import Player from '@vimeo/player';
	import ScrollPosition from '../mixins/scroll-position';

	export default {
		mixins: [ScrollPosition],

		props: {
			playAt: {
				type: Number,
				default: 0
			},

			videoId: {
				required: true,
				type: String
			}
		},

		data() {
			return {
				player: false,
				scrollBottom: 0,
				videoHeight: 0,
			}
		},

		computed: {
			playerId() {
				return '#video-player-' + this.videoId;
			},

			videoDocked() {
				return this.scrollPosition > this.scrollBottom;
			}
		},

		watch: {
			videoId() {
				this.createPlayer();
			},

			playAt(seconds) {
				if(this.player && seconds >= 0) {
					this.player.setCurrentTime(seconds);
					this.$emit('seeked', seconds);
				}
			}
		},

		mounted() {
			this.createPlayer();

			this.updateDimensions();
			window.addEventListener('resize', this.updateDimensions)
		},

		beforeDestroy: function () {
			window.removeEventListener('resize', this.updateDimensions)
	  	},

	  	methods: {
	  		createPlayer() {
				this.player = new Player(this.playerId, { id: this.videoId });
	  		},

	  		updateDimensions() {
	  			this.videoHeight = this.$el.scrollHeight;
				this.scrollBottom = this.$el.getBoundingClientRect().bottom + this.scrollPosition;
	  		}
	  	}
	}
</script>
